module.exports = __webpack_public_path__ + "img/august_1248.3527e04b.png";